/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2020
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports", "@modelcontextprotocol/sdk/types.js", "@modelcontextprotocol/sdk/types.js", "@modelcontextprotocol/sdk/client/index.js", "@modelcontextprotocol/sdk/client/streamableHttp.js"], function (require, exports, types_js_1, types_js_2, index_js_1, streamableHttp_js_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ClientConnection = exports.CallToolResultSchema = exports.ListToolsResultSchema = void 0;
    Object.defineProperty(exports, "ListToolsResultSchema", { enumerable: true, get: function () { return types_js_1.ListToolsResultSchema; } });
    Object.defineProperty(exports, "CallToolResultSchema", { enumerable: true, get: function () { return types_js_1.CallToolResultSchema; } });
    class ClientConnection {
        connect(url) {
            return __awaiter(this, void 0, void 0, function* () {
                let client = new index_js_1.Client({
                    name: 'example-client',
                    version: '1.0.0'
                }, {});
                let sessionId = undefined;
                const fetchWrapper = (url, init) => __awaiter(this, void 0, void 0, function* () {
                    // init.headers[
                    let headers = init.headers;
                    if (headers === null || headers === void 0 ? void 0 : headers.get("mcp-protocol-version")) {
                        headers.delete("mcp-protocol-version");
                    }
                    return fetch(url, init);
                });
                let transport = new streamableHttp_js_1.StreamableHTTPClientTransport(url, {
                    requestInit: {
                        credentials: "include"
                    },
                    sessionId: sessionId,
                    fetch: fetchWrapper
                });
                yield client.connect(transport);
                return client;
            });
        }
        createCallHandler(url) {
            let client = null;
            return (path, requestBody, options) => __awaiter(this, void 0, void 0, function* () {
                const toolCallRequest = {
                    method: "tools/call",
                    params: {
                        name: "mindbreeze_inspire_" + path,
                        arguments: requestBody
                    }
                };
                if (client == null) {
                    client = yield this.connect(url);
                }
                let toolCallResponse = yield client.request(toolCallRequest, types_js_2.CallToolResultSchema);
                if (toolCallResponse.isError) {
                    throw new Error("Failed to perform tool call!");
                }
                return toolCallResponse.structuredContent;
            });
        }
        ;
    }
    exports.ClientConnection = ClientConnection;
});
